import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Config } from 'src/app/utility/config';

@Injectable({
  providedIn: 'root'
})
export class QRCodeService {

  constructor(private http: HttpClient, private config: Config) { }

  getQRCode(): Observable<any> {
    
    const url = this.config.APIUrl + "QRCode";
    return this.http.get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  loginCode(loginCode): Observable<any> {
    
    const url = this.config.APIUrl + "QRT_Attendance/SaveUpdateLoginCode?loginCode=" + loginCode + "&Login_Key=" + this.config.login_Key ;
    return this.http.post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

}
